import classNames from 'classnames';

import { CHART_DIMENSIONS } from './chart-tokens';

const DEFAULT_MESSAGE = 'Chart data unavailable';

export interface InvalidChartProps {
  message?: string;
  className?: string;
}

export const InvalidChart = ({
  message = DEFAULT_MESSAGE,
  className,
}: InvalidChartProps) => (
  <div
    role="img"
    aria-label={message}
    data-testid="invalid-chart"
    className={classNames(
      'flex w-full items-center justify-center rounded border border-dashed border-gray-300 bg-gray-50 text-sm text-gray-500',
      className
    )}
    style={{ height: CHART_DIMENSIONS.defaultHeight }}
  >
    {message}
  </div>
);
